'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _FUNDERS_FORMATTED;

/* ====== START: ERRORS ======= */
var ERROR_MESSAGES = {
  INTERNET_ERROR: 'We are unable to establish an internet connection. We will take you back once you are connected to the internet.',
  NETWORK_ERROR: 'There are issues connecting to the Tyro Health platform. Please refresh the page and try again.',
  SERVER_ERROR: 'There are issues connecting to the Tyro Health platform. Please refresh the page and try again.',
  PAYMENT_GATEWAY_ERROR: 'There are issues connecting to the payment gateway. Please refresh the page and try again.',
  PAYMENT_ERROR: 'An error occurred when processing the payment. Please try again. The card was not charged.',
  PAYMENT_GATEWAY_FIELDS: 'The payment card details you entered were invalid, please review the payment card credentials and try again.'
};
var ERROR_CODES = {
  USERNAME_ALREADY_EXISTS: 10002,
  PAYMENT_PROVIDER_PARAMETERS_INVALID: 10014,
  ACCOUNT_DOES_NOT_HAVE_ACCESS_TO_CHECKOUT_SESSION: 10277,
  CARD_FAILED: 'card-failed'
};
var STANDALONE_ERRORS = {
  noAPIKey: {
    code: 'noAPIKey',
    message: 'Attribute `apiKey` or `token` not found in SDK configuration.'
  },
  noAppID: {
    code: 'noAppID',
    message: 'Attribute `appId` not found in SDK configuration.'
  },
  providerNumberNotFound: {
    code: 'providerNumberNotFound',
    message: 'Provider number not found.'
  },
  providerNumberDoesNotMatchFunder: {
    code: 'providerNumberDoesNotMatchFunder',
    message: 'Provider number does not match funder.'
  }
};
/* ====== END: ERRORS ======= */

/* ====== START: DOCUMENTS ======= */

var DOCUMENT_STATUSES = {
  AVAILABLE: 'available',
  PENDING: 'pending',
  ACTIVE: 'active'
};
var DOCUMENT_TYPES = {
  APPLICATION: 'application',
  FORM: 'form'
};
var DOCUMENT_WORKFLOW_STATES = {
  INBOX: 'inbox',
  ASSIGNED: 'assigned',
  APPROVED: 'approved',
  DECLINED: 'declined',
  CANCELLED: 'cancelled',
  PARKED: 'parked',
  CEASED: 'ceased'
};
var DOCUMENT_WORKFLOW_STATES_HUMANIZED = {
  SUBMITTED: 'Submitted',
  UNDER_REVIEW: 'Under review',
  APPROVED: 'Approved'
};
/* ====== END: DOCUMENTS ======= */

/* ====== START: FORMS ======= */

var FORM_STATUSES = {
  PUBLISHED: 'published',
  DRAFT: 'draft'
};
/* ====== END: FORMS ======= */

/* ====== START: FORM APPLICATIONS ======= */

var FORM_APPLICATION_STATUSES = {
  PENDING: 'pending',
  APPROVED: 'approved',
  DECLINED: 'declined',
  CANCELLED: 'cancelled'
};
/* ====== END: FORM APPLICATIONS ======= */

/* ====== START: FUNDERS ======= */

var FUNDERS = {
  // Note: maps to funder.code
  COMCARE: 'comcare',
  DVA: 'dva',
  ECLIPSE: 'eclipse',
  HBF: 'hbf',
  HEALTHPOINT: 'healthpoint',
  HICAPS: 'nab',
  ICARE: 'icare',
  MEDICARE: 'medicare',
  NIB: 'nib',
  NDIS: 'ndis',
  OHC: 'ohc',
  PATIENT: 'patient-funded',
  QBE: 'qbe',
  WCQ: 'wcq',
  WSV: 'wsv'
};
var FUNDERS_FORMATTED = (_FUNDERS_FORMATTED = {}, _FUNDERS_FORMATTED[FUNDERS.COMCARE] = 'Comcare', _FUNDERS_FORMATTED[FUNDERS.ECLIPSE] = 'ECLIPSE', _FUNDERS_FORMATTED[FUNDERS.HBF] = 'HBF', _FUNDERS_FORMATTED[FUNDERS.HEALTHPOINT] = 'HEALTHPOINT', _FUNDERS_FORMATTED[FUNDERS.HICAPS] = 'HICAPS', _FUNDERS_FORMATTED[FUNDERS.ICARE] = 'icare', _FUNDERS_FORMATTED[FUNDERS.MEDICARE] = 'Medicare', _FUNDERS_FORMATTED[FUNDERS.NDIS] = 'NDIS', _FUNDERS_FORMATTED[FUNDERS.NIB] = 'NIB', _FUNDERS_FORMATTED[FUNDERS.OHC] = 'Overseas health cover', _FUNDERS_FORMATTED[FUNDERS.PATIENT] = 'Patient funded', _FUNDERS_FORMATTED[FUNDERS.QBE] = 'QBE', _FUNDERS_FORMATTED[FUNDERS.WCQ] = 'Workcover Queensland', _FUNDERS_FORMATTED[FUNDERS.WSV] = 'WorkSafe Victoria', _FUNDERS_FORMATTED);
/* ====== END: FUNDERS ======= */

/* ====== START: FUTURES ======= */

var FUTURE_STATUSES = {
  ACTIVE: 'active',
  PENDING: 'pending',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  DECLINED: 'declined',
  ERRORED: 'errored'
};
var FUTURE_TYPES = {
  HOLD: 'hold',
  SUBSCRIPTION: 'subscription',
  INSTALMENT_PLAN: 'instalment-plan'
};
var FUTURE_LABELS = {
  hold: 'Payment hold',
  subscription: 'Subscription',
  'instalment-plan': 'Instalment plan'
};
/* ====== END: FUTURES ======= */

/* ====== START: GATEWAY ======= */

var GATEWAY_CODES = {
  HICAPS_ERROR: '12',
  HICAPS_DOWN: '91',
  MEDICARE_DOWN: '3004'
};
/* ====== END: GATEWAY ======= */

/* ====== START: MISC ======= */

var AUS_STATES = ['Victoria', 'Tasmania', 'Western Australia', 'South Australia', 'Queensland', 'New South Wales', 'Australian Capital Territory', 'Northern Territory'];
/* ====== END: MISC ======= */

/* ====== START: PAYMENTS ======= */

var PAYMENT_FACILITIES = {
  HICAPS_GO: 'hicaps-go',
  MEDIPASS_PAYMENTS: 'medipass-payments'
};
var PAYMENT_PROVIDERS = {
  GOOGLE_PAY: 'google-pay',
  APPLE_PAY: 'apple-pay',
  PAYMENT_CARD: 'payment-card'
};
/* ====== START: PAYMENTS ======= */

/* ====== START: PRODUCT ======= */

var PRODUCTS = {
  BASIC: 'basic',
  PRO: 'pro'
};
var AVAILABLE_PRODUCTS = [PRODUCTS.BASIC, PRODUCTS.PRO];
var PRODUCT_FEATURES = {
  CLAIMING_ADFHS: 'claiming:adfhs',
  CLAIMING_BRIDGE: 'claiming:bridge',
  CLAIMING_COMCARE: 'claiming:comcare',
  CLAIMING_ICARE: 'claiming:icare',
  CLAIMING_MEDICARE: 'claiming:medicare',
  CLAIMING_NDIS: 'claiming:ndis',
  CLAIMING_OHC: 'claiming:ohc',
  CLAIMING_PHI: 'claiming:phi',
  CLAIMING_PHI_QUOTES: 'claiming:phi.quotes',
  CLAIMING_WCQ: 'claiming:wcq',
  PAYMENTS_ASSISTED: 'payments:assisted',
  PAYMENTS_FULLY_PATIENT_FUNDED: 'payments:fully-patient-funded',
  PMS_INTEGRATION: 'pms:integration',
  REPORTING: 'reporting'
};
/* ====== END: PRODUCT ======= */

/* ====== START: STATUSES ======= */

var STATUSES = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
  NEW: 'NEW',
  INVITED: 'INVITED',
  UNVERIFIED: 'UNVERIFIED',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
  ERRORED: 'ERRORED',
  PENDING: 'PENDING',
  EXPIRED: 'EXPIRED'
};
/* ====== END: STATUSES ======= */

/* ====== START: BUSINESS STATUSES ======= */

var BUSINESS_STATUSES = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  DISABLED: 'DISABLED'
};
/* ====== END: BUSINESS STATUSES ======= */

/* ====== START: PAYMENT STATUSES ======= */

var PAYMENT_STATUSES = {
  ACCEPTED: 'accepted',
  APPROVED: 'approved',
  PAID: 'paid',
  PENDING: 'pending',
  SETTLING: 'settling'
};
/* ====== END: PAYMENT STATUSES ======= */

/* ====== START: TRANSACTIONS ======= */

var PAYMENT_TYPES = {
  SALE: 'sale',
  REFUND: 'refund',
  IN_PERSON: 'inperson'
};
var TERMINAL_TRANSACTION_PAYMENT_TYPES = {
  CLAIM: 'claim',
  PAYMENT: 'payment'
};
var TRANSACTION_CLAIM_OPTIONS = {
  TERMINAL: 'terminal',
  PHONE: 'phone',
  GLASS: 'glass'
};
var TRANSACTION_PAYMENT_OPTIONS = {
  PAYMENT_AUTHORITY: 'payment-authority',
  PAY_IN_PERSON: 'pay-in-person',
  PROCESS_OUTSIDE_MEDIPASS: 'process-outside-medipass',
  TERMINAL: 'terminal',
  PHONE: 'phone',
  EXISTING_PAYMENT_CARD: 'existing-payment-card',
  NEW_PAYMENT_CARD: 'new-payment-card',
  PAYMENT_CARD: 'payment-card',
  APPLE_PAY: 'apple-pay',
  GOOGLE_PAY: 'google-pay',
  LINK: 'payment-link',
  HOLD: 'payment-hold',
  INSTALMENT_PLAN: 'instalment-plan'
};
var TRANSACTION_PLATFORM = {
  FUNDER: 'funder',
  VIRTUAL_TERMINAL: 'virtual-terminal',
  FUTURES: 'futures'
};
var TRANSACTION_STATUSES = {
  DISABLED: 'disabled',
  ERRORED: 'errored',
  REQUESTED: 'requested',
  ACCEPTED: 'accepted',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  REVERSED: 'reversed',
  CANCELLED: 'cancelled',
  VOIDED: 'voided',
  SKIPPED: 'skipped',
  REFUNDED: 'refunded',
  PENDING: 'pending',
  NEW: 'new',
  COMPLETED: 'completed',
  PARTIALLY_REFUNDED: 'partially-refunded',
  UNDER_REVIEW: 'under-review',
  SUBMITTED: 'submitted',
  OUTSTANDING: 'outstanding',
  DECLINED: 'declined',
  ARCHIVED: 'archived',
  PAID: 'paid',
  READY: 'ready'
};
var WORKFLOW_STATES = {
  INBOX: 'inbox',
  ASSIGNED: 'assigned',
  PARKED: 'parked',
  SUBMITTED: 'submitted',
  POSTED: 'posted',
  COMPLETED: 'completed',
  ERRORED: 'errored',
  ARCHIVED: 'archived',
  CANCELLED: 'cancelled',
  APPROVED: 'approved',
  ACCEPTED: 'accepted'
};
var ICARE_WORKFLOW_STATES_HUMANIZED = {
  SUBMITTED: 'Submitted',
  APPROVED: 'Approved',
  COMPLETED: 'Completed',
  REJECTED: 'Rejected'
};
/* ====== END: TRANSACTIONS ======= */

/* ====== START: MEDICARE ======= */

var MEDICARE_FORMS = {
  ONLINE_CLAIMING_PROVIDER_AGREEMENT: 'Online Claiming Provider Agreement'
};
/* ====== END: MEDICARE ======= */

/* ====== START: HICAPS FORMS ======= */

var HICAPS_FORMS = {
  CLAIMING_PROVIDER_APPLICATION: 'HICAPS Claiming Application'
};
/* ====== END: HICAPS FORMS ======= */

/* ====== START: PMS ======= */
// Deprecate this once PMS_OPTIONS_LIST is in use

var PMS = ['Best Practice (Allied)', 'Best Practice (Premier)', 'Case Manager', 'Clinic to Cloud', 'Cliniko', 'Coreplus', 'Coviu', 'Dental4Windows', 'Doctors on Demand', 'Exact', 'Front Desk', 'Genie', 'Gensolve', 'Gentu', 'Halaxy / HealthKit', 'Iconpractice', 'Kalysys', 'Lysn', 'Medical Director', 'Medilink', 'Medirecords', 'MedTech', 'My Appointments', 'Myhealth1st', 'Nookal', 'Oasis', 'Owner.health', 'Optomate', 'Powerdiary', 'PPMP', 'PracSuite', 'Shexie', 'Splose', 'Sunix', 'TM2', 'Vinci', 'VisitBase', 'ZedMed', 'Zurili', 'Other'];
var PMS_OPTIONS_LIST = [{
  key: 'Accelerware',
  label: 'Accelerware',
  value: 'Accelerware'
}, {
  key: 'Audit4',
  label: 'Audit4',
  value: 'Audit4'
}, {
  key: 'AutoMed',
  label: 'AutoMed',
  value: 'AutoMed'
}, {
  key: 'BetterClinics',
  label: 'BetterClinics',
  value: 'BetterClinics'
}, {
  key: 'Bluechip',
  label: 'Bluechip',
  value: 'Bluechip'
}, {
  key: 'Best Practice (Allied)',
  label: 'Best Practice (Allied)',
  value: 'Best Practice (Allied)'
}, {
  key: 'Best Practice (Premier)',
  label: 'Best Practice (Premier)',
  value: 'Best Practice (Premier)'
}, {
  key: 'Best Practice (VIP.net)',
  label: 'Best Practice (VIP.net)',
  value: 'Best Practice (VIP.net)'
}, {
  key: 'Capable 21c',
  label: 'Capable 21c',
  value: 'Capable 21c'
}, {
  key: 'CareRight',
  label: 'CareRight',
  value: 'CareRight'
}, {
  key: 'Case Manager',
  label: 'Case Manager',
  value: 'Case Manager'
}, {
  key: 'CCOS by Clinical Computers',
  label: 'CCOS by Clinical Computers',
  value: 'CCOS by Clinical Computers'
}, {
  key: 'Clevero',
  label: 'Clevero',
  value: 'Clevero'
}, {
  key: 'Clinic to Cloud',
  label: 'Clinic to Cloud',
  value: 'Clinic to Cloud'
}, {
  key: 'Cliniko',
  label: 'Cliniko',
  value: 'Cliniko'
}, {
  key: 'Contrast One RIS',
  label: 'Contrast One RIS',
  value: 'Contrast One RIS'
}, {
  key: 'Coreplus',
  label: 'Coreplus',
  value: 'Coreplus'
}, {
  key: 'Core Practice',
  label: 'Core Practice',
  value: 'Core Practice'
}, {
  key: 'Coviu',
  label: 'Coviu',
  value: 'Coviu'
}, {
  key: 'Dental4Web',
  label: 'Dental4Web',
  value: 'Dental4Web'
}, {
  key: 'Dental4Windows',
  label: 'Dental4Windows',
  value: 'Dental 4 Windows'
}, {
  key: 'Dentally',
  label: 'Dentally',
  value: 'Dentally'
}, {
  key: 'Doctors on Demand',
  label: 'Doctors on Demand',
  value: 'Doctors on Demand'
}, {
  key: 'eAlthLTE',
  label: 'eAlthLTE',
  value: 'eAlthLTE'
}, {
  key: 'Exact',
  label: 'Exact',
  value: 'Exact'
}, {
  key: 'Front Desk',
  label: 'Front Desk',
  value: 'Front Desk'
}, {
  key: 'Genie from Magentus',
  label: 'Genie from Magentus',
  value: 'Genie from Magentus'
}, {
  key: 'Gensolve',
  label: 'Gensolve',
  value: 'Gensolve'
}, {
  key: 'Gentu',
  label: 'Gentu',
  value: 'Gentu'
}, {
  key: 'Halaxy',
  label: 'Halaxy',
  value: 'Halaxy'
}, {
  key: 'HealthBank',
  label: 'HealthBank',
  value: 'HealthBank'
}, {
  key: 'Helix',
  label: 'Helix',
  value: 'Helix'
}, {
  key: 'iconpractice',
  label: 'iconpractice',
  value: 'iconpractice'
}, {
  key: 'iinsight',
  label: 'iinsight',
  value: 'iinsight'
}, {
  key: 'LYSN',
  label: 'LYSN',
  value: 'LYSN'
}, {
  key: 'Hey Doc',
  label: 'Hey Doc',
  value: 'Hey Doc'
}, {
  key: 'Medical Wizard',
  label: 'Medical Wizard',
  value: 'Medical Wizard'
}, {
  key: 'Mediclinic',
  label: 'Mediclinic',
  value: 'Mediclinic'
}, {
  key: 'Mediflex',
  label: 'Mediflex',
  value: 'Mediflex'
}, {
  key: 'Medilink',
  label: 'Medilink',
  value: 'Medilink'
}, {
  key: 'Medilink iclient',
  label: 'Medilink iclient',
  value: 'Medilink iclient'
}, {
  key: 'Medtech',
  label: 'Medtech',
  value: 'MedTech'
}, {
  key: 'Mobile Eye Clinic',
  label: 'Mobile Eye Clinic',
  value: 'Mobile Eye Clinic'
}, {
  key: 'My Appointments',
  label: 'My Appointments',
  value: 'My Appointments'
}, {
  key: 'MyHealth 1st',
  label: 'MyHealth 1st',
  value: 'MyHealth 1st'
}, {
  key: 'Medical Director',
  label: 'Medical Director',
  value: 'Medical Director'
}, {
  key: 'MediRecords',
  label: 'MediRecords',
  value: 'MediRecords'
}, {
  key: 'NEXA',
  label: 'NEXA',
  value: 'NEXA'
}, {
  key: 'Nookal',
  label: 'Nookal',
  value: 'Nookal'
}, {
  key: 'Network Logic',
  label: 'Network Logic',
  value: 'Network Logic'
}, {
  key: 'Oasis',
  label: 'Oasis',
  value: 'Oasis'
}, {
  key: 'Owners Health',
  label: 'Owners Health',
  value: 'Owners Health'
}, {
  key: 'Optomate Touch',
  label: 'Optomate Touch',
  value: 'Optomate'
}, {
  key: 'Power diary',
  label: 'Power diary',
  value: 'Power diary'
}, {
  key: 'PPMP',
  label: 'PPMP',
  value: 'PPMP'
}, {
  key: 'PracSuite',
  label: 'PracSuite',
  value: 'PracSuite'
}, {
  key: 'PracSoft',
  label: 'PracSoft',
  value: 'PracSoft'
}, {
  key: 'Practice Master Pro',
  label: 'Practice Master Pro',
  value: 'Practice Master Pro'
}, {
  key: 'Practice Studio',
  label: 'Practice Studio',
  value: 'Practice Studio'
}, {
  key: 'Praktika',
  label: 'Praktika',
  value: 'Praktika'
}, {
  key: 'PrimaryClinic',
  label: 'PrimaryClinic',
  value: 'PrimaryClinic'
}, {
  key: 'Principle',
  label: 'Principle',
  value: 'Principle'
}, {
  key: 'Pabau',
  label: 'Pabau',
  value: 'Pabau'
}, {
  key: 'Practice Pal',
  label: 'Practice Pal',
  value: 'Practice Pal'
}, {
  key: 'Rural Health Connect',
  label: 'Rural Health Connect',
  value: 'Rural Health Connect'
}, {
  key: 'Shexie Platinum',
  label: 'Shexie Platinum',
  value: 'Shexie'
}, {
  key: 'Sunix',
  label: 'Sunix',
  value: 'Sunix'
}, {
  key: 'Splose',
  label: 'Splose',
  value: 'Splose'
}, {
  key: 'SAAS Medical Systems',
  label: 'SAAS Medical Systems',
  value: 'SAAS Medical Systems'
}, {
  key: 'StatHealth',
  label: 'StatHealth',
  value: 'StatHealth'
}, {
  key: 'TM2',
  label: 'TM2',
  value: 'TM2'
}, {
  key: 'TM3',
  label: 'TM3',
  value: 'TM3'
}, {
  key: 'Titanium',
  label: 'Titanium',
  value: 'Titanium'
}, {
  key: 'Ultimo',
  label: 'Ultimo',
  value: 'Ultimo'
}, {
  key: 'Vinci',
  label: 'Vinci',
  value: 'Vinci'
}, {
  key: 'VisitBase',
  label: 'VisitBase',
  value: 'VisitBase'
}, {
  key: 'Xestro',
  label: 'Xestro',
  value: 'Xestro'
}, {
  key: 'Writeupp',
  label: 'Writeupp',
  value: 'Writeupp'
}, {
  key: 'Zavy360',
  label: 'Zavy360',
  value: 'Zavy360'
}, {
  key: 'Zedmed',
  label: 'Zedmed',
  value: 'ZedMed'
}, {
  key: 'Zurili',
  label: 'Zurili',
  value: 'Zurili'
}, {
  key: 'Other',
  label: 'Other',
  value: 'Other'
}];
/* ====== END: PMS ======= */

/* ====== START: VERIFY MEMBER HEALTH FUNDS ======= */

var VERIFY_MEMBER_HEALTH_FUNDS_CODES = ['BUP'];
/* ====== END: VERIFY MEMBER HEALTH FUNDS ======= */

/* ====== START: INVOICE_ORIGINATING_FLOW ======= */

var INVOICE_ORIGINATING_FLOW = {
  ALLIED_PHI: 'allied-phi',
  COMCARE: 'comcare',
  DVA: 'dva',
  ECLIPSE: 'eclipse',
  HEALTHPOINT: 'healthpoint',
  ICARE: 'icare',
  INSTALMENT_PLAN: 'instalment-plan',
  MEDICARE_BULK_BILLED: 'medicare-bulk-billed',
  MEDICARE_PATIENT_CLAIM: 'medicare-patient-claim',
  NDIS: 'ndis',
  NIB: 'nib',
  OVERSEAS_HEALTH_COVER: 'overseas-health-cover',
  PATIENT_FUNDED: 'patient-funded',
  VIRTUAL_TERMINAL: 'virtual-terminal',
  WORK_COVER_QUEENSLAND: 'wcq',
  WORKSAFE_VICTORIA: 'wsv',
  QBE: 'qbe'
};
/* ====== END: INVOICE_ORIGINATING_FLOW ======= */

/* ====== START: STAFF ======= */

var STAFF_TYPES = {
  LOCATION: 'location',
  PERSON: 'person'
};
/* ====== END: STAFF ======= */

/* ====== START: ECLIPSE ======= */

var ECLIPSE_SUB_TYPE = {
  ONLINE_ELIGIBILITY_CHECK: 'onlineEligibilityCheck',
  IN_PATIENT: 'inPatient',
  OVERSEAS: 'overseas'
};
var ECLIPSE_ONLINE_ELIGIBILITY_CHECK_TYPES = {
  MEDICARE_AND_PHI: 'OEC',
  MEDICARE_ONLY: 'ECM',
  FUND_ONLY: 'ECF',
  OVERSEAS: 'ECO'
};
var OEC_MEDICARE_AND_PHI_PROCESSING_CLASSES = {
  AGREEMENTS: 'AG',
  SCHEMES: 'SC',
  PATIENT_CLAIM: 'PC',
  BILLING_AGENT: 'MB'
};
var OEC_OVERSEAS_PROCESSING_CLASSES = {
  AGREEMENTS: 'AG',
  SCHEMES: 'SC',
  PATIENT_CLAIM: 'PC',
  BILLING_AGENT: 'MB'
};
var ECLIPSE_IN_PATIENT_CLAIM_TYPES = {
  BILLING_AGENT: 'MB',
  BILLING_AGENT_MEDICARE_ONLY: 'MO',
  PATIENT_CLAIM: 'PC',
  AGREEMENTS: 'AG',
  SCHEMES: 'SC'
};
var ECLIPSE_OVERSEAS_CLAIM_TYPES = {
  BILLING_AGENT: 'MB',
  PATIENT_CLAIM: 'PC',
  AGREEMENTS: 'AG',
  SCHEMES: 'SC'
};
/* ====== END: ECLIPSE ======= */

exports.AUS_STATES = AUS_STATES;
exports.AVAILABLE_PRODUCTS = AVAILABLE_PRODUCTS;
exports.BUSINESS_STATUSES = BUSINESS_STATUSES;
exports.DOCUMENT_STATUSES = DOCUMENT_STATUSES;
exports.DOCUMENT_TYPES = DOCUMENT_TYPES;
exports.DOCUMENT_WORKFLOW_STATES = DOCUMENT_WORKFLOW_STATES;
exports.DOCUMENT_WORKFLOW_STATES_HUMANIZED = DOCUMENT_WORKFLOW_STATES_HUMANIZED;
exports.ECLIPSE_IN_PATIENT_CLAIM_TYPES = ECLIPSE_IN_PATIENT_CLAIM_TYPES;
exports.ECLIPSE_ONLINE_ELIGIBILITY_CHECK_TYPES = ECLIPSE_ONLINE_ELIGIBILITY_CHECK_TYPES;
exports.ECLIPSE_OVERSEAS_CLAIM_TYPES = ECLIPSE_OVERSEAS_CLAIM_TYPES;
exports.ECLIPSE_SUB_TYPE = ECLIPSE_SUB_TYPE;
exports.ERROR_CODES = ERROR_CODES;
exports.ERROR_MESSAGES = ERROR_MESSAGES;
exports.FORM_APPLICATION_STATUSES = FORM_APPLICATION_STATUSES;
exports.FORM_STATUSES = FORM_STATUSES;
exports.FUNDERS = FUNDERS;
exports.FUNDERS_FORMATTED = FUNDERS_FORMATTED;
exports.FUTURE_LABELS = FUTURE_LABELS;
exports.FUTURE_STATUSES = FUTURE_STATUSES;
exports.FUTURE_TYPES = FUTURE_TYPES;
exports.GATEWAY_CODES = GATEWAY_CODES;
exports.HICAPS_FORMS = HICAPS_FORMS;
exports.ICARE_WORKFLOW_STATES_HUMANIZED = ICARE_WORKFLOW_STATES_HUMANIZED;
exports.INVOICE_ORIGINATING_FLOW = INVOICE_ORIGINATING_FLOW;
exports.MEDICARE_FORMS = MEDICARE_FORMS;
exports.OEC_MEDICARE_AND_PHI_PROCESSING_CLASSES = OEC_MEDICARE_AND_PHI_PROCESSING_CLASSES;
exports.OEC_OVERSEAS_PROCESSING_CLASSES = OEC_OVERSEAS_PROCESSING_CLASSES;
exports.PAYMENT_FACILITIES = PAYMENT_FACILITIES;
exports.PAYMENT_PROVIDERS = PAYMENT_PROVIDERS;
exports.PAYMENT_STATUSES = PAYMENT_STATUSES;
exports.PAYMENT_TYPES = PAYMENT_TYPES;
exports.PMS = PMS;
exports.PMS_OPTIONS_LIST = PMS_OPTIONS_LIST;
exports.PRODUCTS = PRODUCTS;
exports.PRODUCT_FEATURES = PRODUCT_FEATURES;
exports.STAFF_TYPES = STAFF_TYPES;
exports.STANDALONE_ERRORS = STANDALONE_ERRORS;
exports.STATUSES = STATUSES;
exports.TERMINAL_TRANSACTION_PAYMENT_TYPES = TERMINAL_TRANSACTION_PAYMENT_TYPES;
exports.TRANSACTION_CLAIM_OPTIONS = TRANSACTION_CLAIM_OPTIONS;
exports.TRANSACTION_PAYMENT_OPTIONS = TRANSACTION_PAYMENT_OPTIONS;
exports.TRANSACTION_PLATFORM = TRANSACTION_PLATFORM;
exports.TRANSACTION_STATUSES = TRANSACTION_STATUSES;
exports.VERIFY_MEMBER_HEALTH_FUNDS_CODES = VERIFY_MEMBER_HEALTH_FUNDS_CODES;
exports.WORKFLOW_STATES = WORKFLOW_STATES;
